import React from "react";
import ReactDOM from "react-dom/client"; // Correct import for React 18+ (including React 19)
import App from "./App";
// Bootstrap CSS loaded here (from npm) so it comes BEFORE custom overrides
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles.css";
import "./assets/dashboard.css";
import "./assets/deliveryDashboard.css";
import "./assets/iPadResponsive.css";
import "./assets/responsive.css";
import "./assets/crew.css";

import 'leaflet/dist/leaflet.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import "suneditor/dist/css/suneditor.min.css";
import './i8n';
import { LocationPermissionProvider } from './contexts/LocationPermissionContext';
import { AppStoreProvider } from './store/AppStore';

// Strip console.log/debug in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

// Suppress benign ResizeObserver loop error
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <AppStoreProvider>
        <LocationPermissionProvider>
            <App />
        </LocationPermissionProvider>
    </AppStoreProvider>
);